import { render, staticRenderFns } from "./PAYGChangePlansCard.vue?vue&type=template&id=038ebd2d&"
import script from "./PAYGChangePlansCard.vue?vue&type=script&lang=js&"
export * from "./PAYGChangePlansCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports